"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Grid = _interopRequireDefault(require("./Grid"));

var _MonthNames = _interopRequireDefault(require("./MonthNames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const handleMonthSelect = onSelect => idx => {
  return onSelect(idx + 1);
};

const MonthSelector = ({
  className,
  month,
  onSelect
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: className
}, /*#__PURE__*/_react.default.createElement(_Grid.default, {
  items: _MonthNames.default,
  cols: 3,
  select: month - 1,
  onSelect: handleMonthSelect(onSelect)
}));

var _default = (0, _styledComponents.default)(MonthSelector).withConfig({
  displayName: "MonthSelector",
  componentId: "qulyez-0"
})(["display:flex;height:100%;"]);

exports.default = _default;